module.exports = __webpack_public_path__ + "img/icons8_sashimi_96px.0f6efe33.png";